import { Outlet } from "react-router-dom";
import Seo from './Seo'
// import { useSelector, useDispatch } from 'react-redux';
// import { ChangeByPayload } from '../store/ActiveLinkLogic';

import ImgFb from '../img/img_fb.jpg';

const PortfolioPage = () => {
return( 
<>
<Seo
title = "Portfolio Progetti di Grafica, Social e Video | Lorenzo Giralda"
description = "Scopri i lavori di comunicazione visiva realizzati: loghi, brand identity, grafiche pubblicitarie offline e produzioni video per aziende e professionisti."
keywords = "portfolio grafica, progetti logo design, realizzazione brochure, grafiche pubblicitarie, comunicazione visiva, video portfolio, manifesti e locandine"
url="https://giralda-design.web.app/portfolio"
immagine={ImgFb}
></Seo>

<Outlet></Outlet>
</>
)};

export default PortfolioPage;